export const environment = {
    name: 'stage',
    production: true
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts